/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable consistent-return */
import { Button, Flex, Pane, Text } from '@leverege/ui-elements'
import classNames from 'classnames'
import moment from 'moment'
import { useEffect, useMemo, useState } from 'react'
import BondedTable from './components/BondedTable'
import DelayOverviewTable from './components/DelayOverviewTable'
import PaceOverviewCards from './components/PaceOverviewCards'
import ShellsTable from './components/ShellsTable'
import S from './CycleTimeMonitoring.css'

function CycleTimeMonitoring( props ) {
  const fgJob = props?.item?.data?.finishedGoodsJob?.data
  const lineName = props?.item?.name
  const [ isFullScreen, setIsFullScreen ] = useState( false )
  // const { timeKey } = useTimeKeyInterval( 1 )

  const lastUpdated = useMemo( () => moment().format( 'M/D LTS' ), [ fgJob ] )

  useEffect( () => {
    const listener = ( evt ) => {
      if ( document.fullscreenElement ) {
        setIsFullScreen( true )
      } else {
        setIsFullScreen( false )
      }
    }

    document.addEventListener( 'fullscreenchange', listener, { capture : true } )

    return () => {
      document.removeEventListener( 'fullscreenchange', listener, {
        capture : true,
      } )
    }
  }, [] )

  const toggleFullScreen = () => {
    const elem = document.getElementById( 'main_pane' )
    if ( isFullScreen ) return document.exitFullscreen()
    if ( elem.requestFullscreen ) {
      elem.requestFullscreen()
    } else if ( elem.mozRequestFullScreen ) {
      // Firefox
      elem.mozRequestFullScreen()
    } else if ( elem.webkitRequestFullscreen ) {
      // Chrome, Safari and Opera
      elem.webkitRequestFullscreen()
    } else if ( elem.msRequestFullscreen ) {
      // IE/Edge
      elem.msRequestFullscreen()
    }
  }

  const fullScreenStyle = {
    color : isFullScreen ? 'white' : '',
  }

  return (
    <Pane
      id='main_pane'
      className={classNames( S.mainPane, !fgJob ? S.noCollection : '' )}
      style={{
        fontSize : isFullScreen ? 10 : 7.5,
        padding : isFullScreen ? 50 : 6,
      }}>
      <Flex justify='space-between' align='center'>
        <Flex gap={isFullScreen ? 14 : 8} align='center'>
          <Button
            variant={isFullScreen ? 'minimizeButton' : 'expandButton'}
            style={{
              fontSize : '3em',
              padding : 'unset 0',
              ...fullScreenStyle,
            }}
            onClick={toggleFullScreen}/>
          <Text
            variant='screenTitle'
            style={{ fontSize : '3.2em', ...fullScreenStyle }}>
            {fgJob?.jobId ?? '[JOB ID]'}
            {isFullScreen && ` - ${lineName}`}
          </Text>
        </Flex>
        <Text style={{ fontSize : '2.4em', ...fullScreenStyle }}>
          Last Updated: {lastUpdated}
        </Text>
      </Flex>
      <>
        <PaceOverviewCards fgJob={fgJob} isFullScreen={isFullScreen} />
        <Flex gap={14} wrap='wrap' style={{ width : '100%' }}>
          <ShellsTable fgJob={fgJob} isFullScreen={isFullScreen} />
          <BondedTable fgJob={fgJob} isFullScreen={isFullScreen} />
        </Flex>
        <DelayOverviewTable fgJob={fgJob} isFullScreen={isFullScreen} />
      </>
    </Pane>
  )
}

export default CycleTimeMonitoring
